<template>
  <div id="eap">
    <div class="page-header ">
      <div class="content-container row">
        <div class="page-title col-12 pb-5">
          <h2>24/7 Mental Wellbeing Support Programme</h2>
        </div>
        <div class="page-title col-md-12 col-lg-6">
          <p>This service is a confidential programme at no additional cost that provides you and your family members with immediate help and support in managing whatever work or personal issues you are facing. We offer unlimited access for you and your family, to a telephone helpline, available 24 hours a day, 7 days a week, 365 days a year</p>
          <h3 class="text-white pt-2 pb-1">Call us on:</h3>
          <h3 class="text-white  py-1">24/7 Free Phone (Ireland): <a style="color: #4CC2F0;" href="tel:1800911909">1800 911 909</a></h3>
          <h3 class="text-white  pt-1 pb-2">24/7 Free Phone (UK): <a  style="color: #4CC2F0;" href="tel:08000988350">0800 0988 350</a></h3>
          <h3 class="text-white  pt-1 pb-2">Local Number: <a  style="color: #4CC2F0;" href="tel:015180350">01 5180350</a></h3>
          <div class="text-center d-flex text-md-left justify-content-md-start justify-content-center">
            <b-button class="cta-button text-md-center px-4 py-3 my-5" @click="callBack">REQUEST A CALL BACK</b-button>
          </div>
        </div>
        <div class="call-us col-md-12 col-lg-6">
          <div class="video-wrap">
            <div style="padding:56.25% 0 0 0;position:relative; border-radius: 20px; overflow: hidden">
              <iframe src="https://player.vimeo.com/video/954442384?h=35021f5896&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="LAYA EAP VIDEO 2024"></iframe>
            </div>
          </div>
          </div>
      </div>
    </div>
    <div class=" py-5 px-md-5">
      <div class="content-container row">
        <div class="section-header section-header-right">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title text-white">Services Offered</h3>
        </div>
        <div v-for="(card, i) in eapCards" :key="i" class="eap-cards col-md-3 col-sm-6 mb-4 ">
          <div class="eap-card">
            <div class="row align-items-center">
              <div class="col-12 col-lg-5 pr-lg-0 text-center">
                <img class="eap-card-img bg-brand-secondary" :src="card.img_url" alt="eap-type">
              </div>
              <div class="col-12 col-lg-7 pl-1">
                <div class="eap-card-content text-white">
                  {{ card.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white py-4 px-md-5 d-none d-lg-flex">
      <div class="content-container row support">
        <div class="section-header">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title">Our Services Support</h3>
        </div>
        <div v-for="(serviceCard, i) in eapServiceCards" :key="i" class="eap-service-card col-md-5ths px-5">
          <div class="service-card-img-container">
            <img class="service-card-img" :src="serviceCard.img_url" />
          </div>
          <div class="service-card-description bran">
            {{serviceCard.title}}
          </div>
        </div>
      </div>
    </div>
    <div class="articles bg-white px-md-5 pb-5">
      <div class="content-container row">
        <div class="section-header section-header-right">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title">Articles</h3>
        </div>
        <div v-for="(article, index) in articles" :key="index" class="col-md-3 article-wrap">
          <a class="card" @click="selectArticle(article.post_id)">
            <div class="card-header bg-brand-primary">
              <img class="card-logo" :src="'/img/' + img_type[article.post_type]" />
            </div>
            <div class="card-body" ref="cardBody">
              <p class="card-title" ref="cardTitle">{{ article.post_type }}</p>
              <div class="card-text text-eclipse">{{ article.title }}</div>
            </div>
          </a>
        </div>
        <b-link :to="{name: 'allArticles'}" class="text-link">See all articles</b-link>
      </div>
    </div>
    <div v-if="callbackSelected" class="pop-up">
      <div class="pop-up-background" @click="hidePopUp"></div>
      <div class="pop-up-content bg-brand-secondary row">
        <div class="col-12">
          <h4>EAP Call Back</h4>
          <div class="callback-form" v-if="!callBackSuccess">
            <div class="col-md-6 offset-md-3 ">
              <p>Select a service</p>
              <b-form-select class="form-control" v-model="selectedService">
                <option v-for="(service, i) in services" :key="i" :value="service.id">{{service.name}}</option>
              </b-form-select>
            </div>
            <div v-if="selectedService !== ''">
              <div class="service-description py-5 px-5">
                <p>{{ serviceContent }}</p>
              </div>
              <div class="col-md-6 offset-md-3 pb-5">
                <p>Enter Phone Number</p>
                <b-input type='number' class="form-control" v-model="phoneNumber"></b-input>
              </div>
              <div class="d-flex justify-content-center">
                <b-button @click="requestCall" class="cta-button px-5 py-3"> REQUEST A CALL BACK</b-button>
              </div>
            </div>
          </div>
          <div class="callback-confirmation" v-if="callBackSuccess">
            Thank you, please expect a call back from us shortly.
          </div>
        </div>
        <b-button class="close-popup" @click="hidePopUp"><i class="fa fa-times-circle"></i></b-button>
      </div>
    </div>
  </div>
</template>

<script>
    // @ is an alias to /src
    import axios from "axios";
    import config from "@/constants";
    import {
        WEBCHAT_SCHEMA_VERSION,
        WEBCHAT_IFRAME_ID,
        WEBCHAT_GUEST_CLIENT,
        WEBCHAT_REGION,
        getGuestSessionId
    } from "@/helpers/webchat";

    // How long a fresh webchat iframe has to show its launcher before it's taken down.
    const WEBCHAT_BOOT_TIMEOUT_MS = 20000;

    export default {
        name: "eap",
        components: {},
        data() {
            return {
                webchatMessageHandler: null,
                webchatPort: null,
                webchatBootTimer: null,
                callbackSelected: false,
                selectedService: '',
                phoneNumber:'',
                callBackSuccess: false,
                pageData: {},
                articles: [],
                img_type: {
                    video: "video-white.svg",
                    text: "blog-white.svg",
                    image: "far fa-image",
                    audio: "podcast-white.svg"
                },
                eapCards:[
                    {
                        title: 'Mental wellbeing support',
                        img_url: '/img/eap/service-img/mental-wellbeing-support.svg'
                    },
                    {
                        title: 'Financial assistance',
                        img_url: '/img/eap/service-img/financial-assistance.svg'
                    },
                    {
                        title: 'Life coaching',
                        img_url: '/img/eap/service-img/life-coaching.svg'
                    },
                    {
                        title: 'Career counselling',
                        img_url: '/img/eap/service-img/career-counselling.svg'
                    },
                    {
                        title: 'Consumer adviser',
                        img_url: '/img/eap/service-img/consumer-advisor.svg'
                    },
                    {
                        title: 'Mediation',
                        img_url: '/img/eap/service-img/mediation.svg'
                    },
                    {
                        title: 'Support for non-nationals & their families',
                        img_url: '/img/eap/service-img/support-non-irish-national.svg'
                    },
                    {
                        title: 'Legal assistance',
                        img_url: '/img/eap/service-img/legal-assistance.svg'
                    },

                ],
                eapServiceCards:[
                    {
                        title: 'Depression, anxiety & stress',
                        img_url: '/img/eap/service-img/depression.svg'
                    },
                    {
                        title: 'Grief & bereavement',
                        img_url: '/img/eap/service-img/grief.svg'
                    },
                    {
                        title: 'Addictions',
                        img_url: '/img/eap/service-img/addiction.svg'
                    },
                    {
                        title: 'Relationship & marital problems',
                        img_url: '/img/eap/service-img/relationship.svg'
                    },
                    {
                        title: 'Work stress & work-life balance issues',
                        img_url: '/img/eap/service-img/work-stress.svg'
                    },
                ],
                services:[
                    { id: 1, name: 'Financial Assistance', content: "Our Qualified Financial Advisors are available to provide timely and informed guidance around money worries or queries. They can provide consultation on a wide range of financial issues from budgeting and investing, right through to investing and preparing for your retirement."},
                    { id: 7, name: 'Legal Assistance', content: "If you face a legal situation or have a question on a legal issue that you would like to discuss with a trained legal professional, our EAP can provide consultations with a team of solicitors who can provide assistance for a wide range of legal issues."},
                    { id: 2, name: 'Life Coaching', content: "Life Coaching can help to promote self-awareness, enhance skills and clarify visions, intentions and goals. Whilst not to be confused with counselling, life coaching is appropriate for those who are ready to take action in their lives and can be valuable during times of personal or professional change."},
                    { id: 3, name: 'Career Counselling', content: "The EAP can assist you in the planning, management and development of jobs, careers and occupations. Our case managers can connect you with a career coach who can discuss how coaching could help you to achieve excellence through customised career development solutions and training."},
                    { id: 4, name: 'Consumer Advice', content: "Our EAP team are trained to identify any consumer issues that you may have. Understanding your rights as a consumer is key to safeguarding those rights. We will direct you towards the relevant information or experts, ensuring that you are fully informed of your rights and legal stand point as a consumer."},
                    { id: 5, name: 'Mediation', content: "Mediation is a confidential, flexible, voluntary, impartial and informal approach to conflict resolution. Our mediation information service is aimed at helping you figure out if mediation could help find a mutually acceptable resolution to a conflict you may be facing, whether it may be in your own workplace, or with a third party."},
                    { id: 6, name: 'Support for Non-Nationals', content: "For non-nationals and their families, making a smooth transition into a new country can be daunting. Our team can provide information and guidance on a range of issues including finance, education, health services, entitlements, and many more. We can help ensure you and your family are ready for any potential obstacles when settling into your new life."},
                    { id: 0, name: 'Mental Wellbeing Support', content: "Our expertly trained team are on hand 24/7 to provide advice and guidance on a wide range of everyday services and issues relating to areas such as the home, family, childcare or travelling. We can assist directly or refer you to experts or services in each area along with providing information and resources relevant to your individual case."},
                ],
            };
        },
        mounted() {
            this.getResourceList()
            if (config.use_twilio_webchat) {
                this.loadTwilioWebchat()
            } else {
                this.salesforceDemo()
            }
            // this.enableZendeskWidget()
        },
        destroyed(){
            if (config.use_twilio_webchat) {
                // Never heard from it: remove rather than hide, so a return visit starts a
                // fresh iframe instead of reusing one that may never boot.
                if (this.webchatBootTimer) {
                    this.removeTwilioWebchat()
                    return
                }
                // Booted: keep it warm (document.body outlives this page) so a return visit
                // shows the same conversation. Our end of the channel goes; a revisit
                // re-handshakes.
                this.closeWebchatChannel()
                const iframe = document.getElementById(WEBCHAT_IFRAME_ID)
                if (iframe) iframe.style.display = "none"
                return
            }
            // MessageBird may not have injected its widget yet if the page is left quickly.
            let sf = document.getElementById('live-chat-widget');
            if (sf) sf.style.display = "none";
            //remove zendesk
            // if(window.$zopim) {
            //   window.$zopim.livechat.hideAll()
            // }
        },
        computed: {
          serviceContent() {
            const i = this.services.findIndex(svc => svc.id === this.selectedService);
            return this.services[i].content;
          }
        },
        methods: {
            callBack(){
                this.callbackSelected = true
            },
            async getResourceList(){
                const payload = {
                    user_id: "LayaEAP",
                    "search_key":"",
                    "filter":"",
                    "tag":"mind",
                    "fav_only":"0",
                    "page":"0",
                    "page_size":"4",
                    "surge_only":1
                }
                let res= await axios.post(config.api_env + '/application/api-hc/get-all-resource-list', payload, config.options)
                if(res.data.success){
                    this.articles = res.data.resources
                }

            },
            selectArticle(articleId){
                this.$router.push('/wellbeing/article/'+ articleId)
            },
            async requestCall(){
                let payload = {
                    user_id: "LayaEAP",
                    phone: this.phoneNumber,
                    service_id: this.selectedService
                }
                let res = await axios.post(config.api_env + '/application/api-hc/send-eap-request', payload, config.options)
                if(res.data.sent){
                    this.callBackSuccess = true
                }
            },
            hidePopUp(){
                this.callbackSelected = false
                this.selectedService = ''
                this.callBackSuccess = false
            },
            salesforceDemo() {
                let sf = document.getElementById('live-chat-widget');
                if(sf) {
                    sf.style.display = "initial";
                } else {
                    let script = document.createElement('script');
                    script.src = "/assets/salesforce_Script.js";
                    script.type = "text/javascript";
                    script.charset = "UFT-8";
                    script.setAttribute("id","sf-script")
                    document.head.appendChild(script);
                }
            },
            // Spectrum-hosted Twilio webchat (live-webchat) in guest mode, in place of
            // MessageBird. Driven by the webchat:* contract in
            // live-webchat/src/contracts/embed.ts; ported from AXA web (CR-133).
            loadTwilioWebchat() {
                // A missing VUE_APP_WEBCHAT_URL is a build misconfiguration: no chat.
                if (!config.webchat_url) {
                    // This app has no Sentry, so the console is the only trace of a failed chat.
                    // eslint-disable-next-line no-console
                    console.error("Not loading Twilio webchat: VUE_APP_WEBCHAT_URL missing")
                    return
                }
                const webchatOrigin = new URL(config.webchat_url).origin
                let iframe = document.getElementById(WEBCHAT_IFRAME_ID)
                const isWarmIframe = Boolean(iframe)
                if (iframe) {
                    iframe.style.display = "block"
                } else {
                    iframe = document.createElement("iframe")
                    iframe.id = WEBCHAT_IFRAME_ID
                    iframe.src = config.webchat_url
                    iframe.title = "Live chat"
                    // Cross-origin embed: allow-scripts + allow-same-origin are both needed (an
                    // opaque origin breaks the SDK's localStorage); the value is in what's
                    // withheld, above all allow-top-navigation. popups/downloads carry links and
                    // attachments in a conversation.
                    iframe.setAttribute(
                        "sandbox",
                        "allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
                    )
                    iframe.setAttribute("allow", "clipboard-write")
                    document.body.appendChild(iframe)
                    // Only a fresh iframe has to prove it boots; a warm one already has.
                    this.webchatBootTimer = setTimeout(() => {
                        // eslint-disable-next-line no-console
                        console.error(`Twilio webchat did not start within ${WEBCHAT_BOOT_TIMEOUT_MS / 1000}s`)
                        this.removeTwilioWebchat()
                    }, WEBCHAT_BOOT_TIMEOUT_MS)
                }

                if (this.webchatMessageHandler) {
                    window.removeEventListener("message", this.webchatMessageHandler)
                }
                // Only webchat:ready arrives over the window — it's the signal to open the
                // channel, so it can't travel over a port that doesn't exist yet.
                const handler = event => {
                    if (event.origin !== webchatOrigin) return
                    const message = event.data
                    if (!message || typeof message !== "object") return
                    if (message.type !== "webchat:ready") return
                    if (message.v !== WEBCHAT_SCHEMA_VERSION) return
                    if (typeof message.offsetBottom === "number") {
                        iframe.style.setProperty("--webchat-offset-bottom", `${message.offsetBottom}px`)
                    }
                    if (typeof message.offsetRight === "number") {
                        iframe.style.setProperty("--webchat-offset-right", `${message.offsetRight}px`)
                    }
                    this.openWebchatChannel(iframe, webchatOrigin)
                }
                window.addEventListener("message", handler)
                this.webchatMessageHandler = handler

                // A warm iframe already sent webchat:ready and won't again, so open the channel
                // ourselves. The webchat swaps to the newest port and keeps its session.
                if (isWarmIframe) {
                    this.openWebchatChannel(iframe, webchatOrigin)
                }
            },
            openWebchatChannel(iframe, webchatOrigin) {
                if (!iframe.contentWindow) return
                if (this.webchatPort) {
                    this.webchatPort.onmessage = null
                    this.webchatPort.close()
                }
                const channel = new MessageChannel()
                this.webchatPort = channel.port1
                channel.port1.onmessage = event => this.onWebchatPortMessage(event.data, iframe)
                iframe.contentWindow.postMessage(
                    { type: "webchat:connect", v: WEBCHAT_SCHEMA_VERSION },
                    webchatOrigin,
                    [channel.port2]
                )
                // Guest init: no token, since Laya has no login. The pre-chat form collects
                // name and email; guestSessionId keeps one conversation per browser tab.
                channel.port1.postMessage({
                    type: "webchat:init",
                    v: WEBCHAT_SCHEMA_VERSION,
                    displayMode: "widget",
                    // The launcher bubble shows on load in place of MessageBird's; the visitor
                    // opens it.
                    autoOpen: false,
                    region: WEBCHAT_REGION,
                    client: WEBCHAT_GUEST_CLIENT,
                    guestSessionId: getGuestSessionId()
                })
            },
            onWebchatPortMessage(message, iframe) {
                if (!message || typeof message !== "object") return
                if (message.v !== WEBCHAT_SCHEMA_VERSION) return
                switch (message.type) {
                    // The webchat reports collapsed as soon as its launcher mounts, so either
                    // state means it booted.
                    case "webchat:expanded":
                        iframe.classList.add("expanded")
                        this.clearWebchatBootTimer()
                        break
                    case "webchat:collapsed":
                        iframe.classList.remove("expanded")
                        this.clearWebchatBootTimer()
                        break
                    case "webchat:error":
                        // Couldn't boot (invalid init, unprovisioned region, outage). Take the
                        // dead iframe down rather than leave an invisible overlay; the phone
                        // numbers and call-back are unaffected.
                        // eslint-disable-next-line no-console
                        console.error(`Twilio webchat failed to start: ${message.code || "unknown"}`)
                        this.removeTwilioWebchat()
                        break
                }
            },
            clearWebchatBootTimer() {
                if (!this.webchatBootTimer) return
                clearTimeout(this.webchatBootTimer)
                this.webchatBootTimer = null
            },
            closeWebchatChannel() {
                this.clearWebchatBootTimer()
                if (this.webchatMessageHandler) {
                    window.removeEventListener("message", this.webchatMessageHandler)
                    this.webchatMessageHandler = null
                }
                if (this.webchatPort) {
                    this.webchatPort.onmessage = null
                    this.webchatPort.close()
                    this.webchatPort = null
                }
            },
            removeTwilioWebchat() {
                this.closeWebchatChannel()
                const iframe = document.getElementById(WEBCHAT_IFRAME_ID)
                if (iframe) iframe.remove()
            },
            enableZendeskWidget(){
                // window.$zopim||(function(d,s){
                //     var z = window.$zopim = function(c){
                //             z._.push(c)
                //         },
                //         $ = z.s = d.createElement(s), e = d.getElementsByTagName(s)[0];
                //     z.set = function(o){
                //         z.set._.push(o)
                //     };
                //     z._ = [];
                //     z.set._ = [];
                //     $.async=!0;
                //     $.setAttribute("charset","utf-8");
                //     $.setAttribute("id","ze-snippet");
                //     // $.src="https://static.zdassets.com/ekr/snippet.js?key=231b7a97-95a0-4837-86a2-5be70b3b9db1";
                //     $.src="https://static.zdassets.com/ekr/snippet.js?key=970fec74-4d7c-4d50-8479-05468b79e57a";
                //     z.t=+new Date;
                //     $.type="text/javascript";
                //     e.parentNode.insertBefore($,e)
                // })(document,"script");

            }
        },
        watch:{
        }
    };
</script>
<style lang="less">
  @import "../assets/_theme-0";
  #eap {
    .page-header {
      padding: 60px 0 0 0;
      .page-title {
        text-align: left;
        h2 {
          text-align: left;
          font-size: 3.8rem;
          letter-spacing: 0.7rem;
          font-family: ff-cocon-web-pro, sans-serif;
          color: #fff;
        }
        p{
          font-size: 2.2rem;
          font-family: ff-sari-web-regular, sans-serif;
          color: #fff;
        }
      }
      .call-us{
        text-align: right;
        img{
          max-width: 220px;
        }
        h3 {
          font-family: ff-sari-web-regular, sans-serif;
          font-size: 3.5rem;
          letter-spacing: 0;
          color: #fff;
          font-weight: 100;
          padding-top: 20px;
        }
        .btn{
          font-size: 1.3rem;
          font-family: ff-cocon-web-pro, sans-serif;
        }
      }
      .video-wrap {
        border-radius: 20px;
        -o-object-fit: fill;
        object-fit: fill;
        .video {
          -o-object-fit: fill;
          object-fit: fill;
          border-radius: 20px;
          &:focus {
            outline: none;
          }
        }
      }
    }
    .eap-cards{
      .eap-card {
        .eap-card-img {
          border-radius:50%;
          width: 100%;
          height: 100%;
          max-width: 100px;
        }
        .eap-card-content{
          font-family: FilsonProLight, sans-serif;
          font-size: 2.1rem;
          line-height: 2.3rem;
          letter-spacing: 0;
        }
      }
    }
    .eap-service-card {
      &:not(:last-of-type)::after {
        content: "";
        position: absolute;
        top: 70%;
        right: 0;
        width: 1px;
        height: 30%;
        transform: translateY(-50%);
        background: #cccccc;
      }
      .service-card-img-container{
        height: 90px;
        .service-card-img{
          height: 90px;
          transform: translateX(25%);
          width: 65%;
          z-index: 2;
        }
      }
      .service-card-description{
        font-family: FilsonProBook, sans-serif;
        margin-top: 20px;
        font-size: 1.8rem;
        line-height: 1.2;
        text-align: center;
        letter-spacing: 0;
      }
    }
    .support{
      padding-bottom: 80px;
    }
    .pop-up{
      display: flex;
      align-items: center;
      z-index: 500;
      position:fixed;
      top:0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      overflow-y: scroll;
      .pop-up-content{
        max-width: 636px;
        width: 100%;
        margin: auto;
        border-radius: 25px;
        padding: 50px 20px;
        font-size: 1.6rem;
        text-align: center;
        z-index: 10;
        color: #fff;
        position: relative;
        p{
          color: #fff;
        }
        h4{
          font-family: 'FilsonProBold', sans-serif;
          font-size: 3.8rem;
          color: #fff;
        }
        .form-control{
          height: 30px;
          border-radius: 5px;
          font-size: 1.6rem;
        }
        .service-description{
          text-align: left;
        }
        .close-popup{
          position: absolute;
          top: 0;
          right: 0;
          background-color: transparent;
          width: 50px;
          height:50px;
          svg{
            width: 30px;
            height: 30px;
          }
        }
      }
      .pop-up-background{
        width: 100vw;
        height: 100vh;
        position: absolute;
        left: 0;
        right: 0;
        z-index: 5;
        background: transparent;
      }
    }
    .articles();
  }

  // Twilio webchat iframe (CR-414) — appended to <body>, so top-level, not under #eap.
  // The id must stay in sync with WEBCHAT_IFRAME_ID in @/helpers/webchat.js.
  #twilio-webchat-iframe {
    position: fixed;
    // Offsets come from the webchat on webchat:ready (16px default).
    right: var(--webchat-offset-right, 16px);
    bottom: var(--webchat-offset-bottom, 16px);
    width: 40px;
    height: 40px;
    border: 0;
    z-index: 100000;
    background: transparent;

    // Floating corner panel; max-height keeps it clip-free above Twilio's ~646px window.
    &.expanded {
      width: 400px;
      height: 700px;
      max-height: calc(100vh - 80px);
    }

    // Narrow/short viewport: fill the screen. Keep right/bottom so the corner stays
    // anchored on expand — only top/left move.
    @media (max-width: 600px), (max-height: 725px) {
      &.expanded {
        // The webchat is transparent in widget mode; full screen, the strip around its
        // launcher would otherwise show the page through.
        background: #fff;
        top: 16px;
        left: 16px;
        // iframes don't fill via height:auto (defaults to 150px) — set them explicitly.
        width: calc(100vw - 32px);
        height: calc(100vh - var(--webchat-offset-bottom, 16px) - 16px);
        max-height: none;
      }
    }
  }
</style>
